import { Actions, RadioGroupInput } from "@cpj-ai/panel-npm-package";
import { OrgRegistrationStepEnum, useOrganizationProfileStore } from "@store/useOrganizationProfileStore";
import { useCallback } from "react";
import { useForm } from "react-hook-form";
import VerificationLayout from "../VerificationMethods/VerificationMethodLayout";

interface FormValues {
  method: OrgRegistrationStepEnum;
}

const VERIFICATION_METHODS = [
  {
    title: "Mail and call Organization Administrator",
    description:
      "In this method, you should authenticate using your company's domain and according to the mentioned method",
    value: OrgRegistrationStepEnum.verifyWithEmail,
    disabled: false,
  },
  {
    title: "Domain TXT Record",
    description:
      "In this method, you should authenticate using your company's domain and according to the mentioned method",
    value: OrgRegistrationStepEnum.verifyWithDomainTxtRecord,
    disabled: true,
  },
  {
    title: "Uploading File to the Website Hosting Root",
    description:
      "In this method, you should authenticate using your company's domain and according to the mentioned method",
    value: OrgRegistrationStepEnum.verifyWithUploadFileToHost,
    disabled: true,
  },
  {
    title: "Upload company certificate",
    description:
      "In this method, you should authenticate using your company's domain and according to the mentioned method",
    value: OrgRegistrationStepEnum.verifyWithUploadCertificate,
    disabled: true,
  },
] as const;

const SelectVerificationMethod = () => {
  const { setOrgRegistrationStep } = useOrganizationProfileStore();
  const { handleSubmit, setValue, watch } = useForm<FormValues>({
    defaultValues: {
      method: OrgRegistrationStepEnum.verifyWithEmail,
    },
  });

  const selectedMethod = watch("method");

  const onSubmit = useCallback(
    (data: FormValues) => {
      if (Object.values(OrgRegistrationStepEnum).includes(data.method)) {
        setOrgRegistrationStep(data.method);
      }
    },
    [setOrgRegistrationStep],
  );

  return (
    <VerificationLayout showTypeSection={false}>
      <div className="space-y-6">
        <h2 className="text-lg font-semibold text-gray-900">Choose one of the authentication methods:</h2>

        <RadioGroupInput
          name="verification-method"
          classNames={{
            wrapper: "flex flex-col gap-10",
          }}
          radioClassNames={{
            base: "border rounded-xl border-zinc-200 p-4 w-full max-w-none transition-colors hover:bg-zinc-50  data-[selected=true]:border-success",
          }}
          defaultValue={OrgRegistrationStepEnum.verifyWithEmail}
          items={VERIFICATION_METHODS.map((method) => ({
            label: (
              <div className="flex flex-col gap-2">
                <p className="text-sm font-medium text-gray-900">{method.title}</p>
                <p className="text-xs text-gray-500">{method.description}</p>
              </div>
            ),
            value: method.value,
            disabled: method.disabled,
          }))}
          onChange={(e) => {
            setValue("method", e.target.value as OrgRegistrationStepEnum);
          }}
        />

        <Actions
          showCancel={false}
          submitProps={{
            onClick: handleSubmit(onSubmit),
            isDisabled: !selectedMethod,
            children: "Next",
          }}
        />
      </div>
    </VerificationLayout>
  );
};

export default SelectVerificationMethod;
